import { useTheme } from "@mui/material";
import { Skeleton } from "@kaltura/mediaspace-shared-styled";
import styled from "@emotion/styled";

const StyledSkeletonContainer = styled("div")(({ theme }) => ({
    display: "flex",
    gap: theme.spacing(2),
}));

export function FolderInfoPanelSkeleton() {
    const theme = useTheme();

    return (
        <StyledSkeletonContainer>
            <Skeleton variant={"rectangular"} height={theme.spacing(3)} width={80} />
            <Skeleton variant={"rectangular"} height={theme.spacing(3)} width={80} />
            <Skeleton variant={"rectangular"} height={theme.spacing(3)} width={80} />
        </StyledSkeletonContainer>
    );
}

export default FolderInfoPanelSkeleton;
